import $ from "jquery"

// function fmtParam(params, param, fmter) {
//     if (params[param]) {
//         var val = params[param]
//         delete params[param]
//         if (fmter) {
//             return fmter(val)
//         } else {
//             return val
//         }
//     }
// }

// var rimSlider = document.getElementById('nouislider-2')
// var rimStdProps = {}
// if (rimSlider) {
//     rimStdProps = rimSlider.dataset
// }


$('.branch-block').click(function () {
    var iframe_link = $(this).data('iframe-link');
    if (iframe_link) {
        $('.map-iframe').attr('src', iframe_link);
    }
})

$('.payment-item').click(function () {
    if ($(this).data('show-file-block') == true) {
        $('#basket-file-wrap').fadeIn();
    } else {
        $('#basket-file-wrap').attr("style", "display: none !important");
    }
    if ($(this).data('show-split-block') == true) {
        $('#yaWidget').fadeIn();
    } else {
        $('#yaWidget').attr("style", "display: none !important");
    }
});


// function addSelOptions(dataList, el) {
//     dataList.forEach(item => el.append(
//         $('<option>', {
//             value: item.urlname.replaceAll("_", "-"),
//             text: item.name
//         }))
//     )
// }

// function getCarSearchRimType(form) {
//   if (!form) {
//     return null;
//   }

//   form = $(form)
//   if (form.length && form[0].getAttribute('action').indexOf('diski') != -1) {
//     return window.location.href.indexOf('/forged/') != -1 ? 'forged' : 'alloy';
//   }
  
//   return null;
// }

// function getSearchParams(k) {
//     var p = {};
//     location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (s, k, v) {
//         p[k] = v
//     })
//     return k ? p[k] : p;
// }

// function createQueryString(params) {
//     let string = '';
//     let i = 0
//     $.each(params, function (key, value) {
//         if (i == 0) {
//             string += '?';
//             string += key + '=' + value;
//         } else {
//             string += '&' + key + '=' + value;
//         }
//         i += 1;
//     })
//     return string;
// };
